// Shared brand data — single source of truth for both apps. Generated/maintained;
// edit here, not the per-app overlays. APP_BUNDLES carries exam_name/exam_code (mobile
// reads them; web ignores). See docs/app-constant-usage-audit.md.
// vendor/display_name drive the two-line onboarding exam chips (same vocabulary as
// the Welcome screen exam grid); brands without them fall back to exam_name.
// exam_full_name is the full official cert name — the web Switch Exam dialog and
// GET_EXAM_DISPLAY_TITLE (page header) render it; surfaces fall back to title.
export const APP_BUNDLES = [
    {
        title: 'AIGP',
        key: 'aigp',
        description: "IAPP Artificial Intelligence Governance Professional (AIGP)",
        exam_name: 'IAPP AIGP',
        exam_code: '',
        exam_full_name: 'IAPP AI Governance Professional (AIGP)',
        vendor: 'IAPP',
        display_name: 'AIGP',
        bundle_firebase_collection_name: 'AIGP',
    },
    {
        title: 'SecAI+',
        key: 'secaiplus',
        description: "CompTIA SecAI+ (CY0-001)",
        exam_name: 'CompTIA SecAI+',
        exam_code: 'CY0-001',
        exam_full_name: 'CompTIA SecAI+',
        vendor: 'CompTIA',
        display_name: 'SecAI+',
        bundle_firebase_collection_name: 'SECAIPLUS',
    },
    {
        title: 'AWS AI Practitioner',
        key: 'awscaip',
        description: "AWS Certified AI Practitioner (AIF-C01)",
        exam_name: 'AWS AI Practitioner',
        exam_code: 'AIF-C01',
        exam_full_name: 'AWS Certified AI Practitioner',
        vendor: 'AWS',
        display_name: 'AI Practitioner',
        bundle_firebase_collection_name: 'AWSCAIP',
    },
    {
        title: 'AWS ML Engineer',
        key: 'awsmle',
        description: "AWS Certified Machine Learning Engineer (MLA-C01)",
        exam_name: 'AWS ML Engineer',
        exam_code: 'MLA-C01',
        exam_full_name: 'AWS Certified Machine Learning Engineer',
        vendor: 'AWS',
        display_name: 'ML Engineer',
        bundle_firebase_collection_name: 'AWSMLE',
    },
    {
        title: 'GitHub Copilot',
        key: 'ghcpc',
        description: "GitHub Copilot Certification",
        exam_name: 'GitHub Copilot',
        exam_code: '',
        exam_full_name: 'GitHub Copilot Certification',
        vendor: 'GitHub',
        display_name: 'Copilot',
        bundle_firebase_collection_name: 'GHCPC',
    },
    {
        title: 'DataAI',
        key: 'dataai',
        description: "CompTIA DataAI (DY0-001)",
        exam_name: 'CompTIA DataAI',
        exam_code: 'DY0-001',
        exam_full_name: 'CompTIA DataAI',
        vendor: 'CompTIA',
        display_name: 'DataAI',
        bundle_firebase_collection_name: 'DATAAI',
    }
]

export const EXAM_TITLES = {
  aigp: 'AIGP',
  secaiplus: 'SecAI+',
  awscaip: 'AWSCAIP',
  awsmle: 'AWSMLE',
  ghcpc: 'GHCPC',
  dataai: 'DATAAI',
}

export const BUNDLE_APP_NAME = "AICERTS_BUNDLE";

export const IS_BUNDLE_APP = true;

// Paywall headline (two lines; line2 is the accent line). Shared by web + mobile
// so both surfaces render one headline. Consumed via @learnzapp/core/pricing
// resolveHeadline, which fills a fallback if either line is blank.
export const PAYWALL_COPY = {
    headline: {
        line1: 'Everything You Need to',
        line2: 'Pass Your AI Certs',
    },
};
